import React from "react";
import NascarOptimizer from "./NascarOptimizer";

export default function XfinityOptimizerPage() {
  return <NascarOptimizer forcedSeries="xfinity" />;
}
